import { useTheme } from "styled-components";
import React, { useState } from "react";
import Styled from "./styled";
import Text from "../text";

const Button = ({
  title = "",
  color = "primary",
  success = false,
  shape = "round",
  className = "",
  onClick = async () => {},
  classNames = {},
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const { token } = useTheme();

  const onClickButton = async () => {
    setLoading(true);
    try {
      await onClick();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Styled
      shape={shape}
      loading={loading}
      success={success}
      onClick={onClickButton}
      color={token.actions[color] || token.actions.primary}
      className={`${color}-color ${className}`}
      {...props}
    >
      {!loading && (
        <Text
          weight={"600"}
          children={title}
          style={{ color: "inherit" }}
          className={classNames?.title}
        />
      )}
    </Styled>
  );
};

export default Button;
